import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SHELL_HOME_URL } from '../../../core/shell/shell-routes.constant';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { ErrorStateComponent } from '../../components/error-state/error-state.component';
import { MAX_RETRY_ATTEMPTS } from '../../constants/error-state.constant';
import { SERVICE_ERROR_TEXTS } from '../../constants/service-error.constant';
import { SUBSCRIPTION_URLS } from '../../constants/subscription-routes.constant';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'app-service-error-page',
  templateUrl: './service-error.page.html',
  imports: [BreadcrumbComponent, ErrorStateComponent],
})
export class ServiceErrorPage {
  readonly texts = SERVICE_ERROR_TEXTS;

  attempts: number = 0;
  isRetrying: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly subscriptionSvc: SubscriptionService
  ) {}

  get canRetry(): boolean {
    return this.attempts < MAX_RETRY_ATTEMPTS;
  }

  get subtitle(): string {
    return this.canRetry
      ? this.texts.subtitle
      : this.texts.subtitleWithoutRetries;
  }

  async retry(): Promise<void> {
    if (!this.canRetry || this.isRetrying) return;

    this.attempts += 1;
    this.isRetrying = true;

    try {
      await this.subscriptionSvc.prepareEntry();
      await this.router.navigate([SUBSCRIPTION_URLS.amount]);
    } catch (error) {
      console.error('Error retrying subscription entry', error);
    } finally {
      this.isRetrying = false;
    }
  }

  goHome(): void {
    this.router.navigate([SHELL_HOME_URL]);
  }
}
